<template>
  <div class="col left-navbar-container d-none d-sm-block">
    <div class="left-navbar pt-5">
      <ul>
        <li id="codes" :class="{ active: isPhoneCodes }">
          <router-link :to="{ name: 'phoneCodes'}" class="icon-container">
            <i class="material-icons">phone</i>
            <p class="d-none d-sm-inline"> Phone codes</p>
          </router-link>
        </li>
        <li id="articles" :class="{ active: isArticles }">
          <router-link :to="{ name: 'articles'}" class="icon-container">
            <i class="material-icons">view_list</i>
            <p class="d-none d-sm-inline"> Articles</p>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'IcgLeftNav',
  mounted () {
    this.isPhoneCodes = this.$route.path.indexOf('phonecode') !== -1
    this.isArticles = this.$route.path.indexOf('articles') !== -1
  },
  data () {
    return {
      isPhoneCodes: false,
      isArticles: false
    }
  }
}
</script>

<style lang="scss" scoped>
.left-navbar-container {
  min-height: calc(100vh - 60px);
  padding: 0;
  max-width: 200px;
}

.left-navbar {
  position: fixed;
  width: 200px;
  background-color: rgb(65, 72, 81);
  color: rgb(255, 255, 255);
  height: calc(100vh - 60px);

  ul {
    padding: 0;

    &.push-bottom {
      position: absolute;
      bottom: 0;
    }

    li {
      list-style: none;

      &:hover {
        background-color: rgb(106, 111, 118);
      }

      a {
        color: #FFFFFF;
        padding: 30px;
        display: block;
        width: 100%;
        height: 100%;

        &:hover {
          text-decoration: none;
        }
      }

      &.active {
        background-color: rgb(106, 111, 118);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/IcgLeftNav.vue